import React from 'react'
import '../App.css';
import Banner from '../Banner/Banner';
import Body from '../Body/Body';
import Centerexp from '../Center-Exp/Center_Exp';
import Footer from '../Footer/footer';
import Slider from '../Swiperjs/Slider';
function Home() {
  return (
    <>
      <Banner />
      <Body />
      <Centerexp />
      <Slider />
      <Footer />
    </>
  )
}

export default Home